'use client';

import { Tab } from './tab';

export type TabsListProps = {
	active: string;
	options: any[];
	onChange: (key: string) => void;
};

export function TabsList({ active, options, onChange }: TabsListProps) {
	return options.map((child) => {
		return (
			<Tab
				key={child.props.name}
				name={child.props.name}
				title={child.props.title}
				active={child.props.name === active}
				onClick={onChange.bind(null, child.props.name)}
			/>
		);
	});
}
